export const DevKitSection: React.FC<{ title: string }> = ({ title, children }) => {
  return (
    <div className="my-4 rounded p-4 shadow">
      <h3 className="mb-2 text-center font-bold">{title}</h3>
      {children}
    </div>
  );
};
